/*
 * @Description: 职能快捷退单
 * @Author: 杨志航
 * @Date: 2026-05-08 17:05:35
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Main from './Main'
import RefundInfo from './RefundInfo'
import RefundApply from '../../OrderDirect/module/RefundApply'

const AchAudit = ({ match, history }) => {

  return (
    <Switch>
      <Route path={match.path + '/refundinfo'} component={RefundInfo} />
      <Route path={match.path + '/refundapply'} component={RefundApply} />
      <Route component={Main} />
    </Switch>
  )
}

export default AchAudit